import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users } from "lucide-react";

function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.max(0, Math.floor((now - then) / 1000));
  if (diff < 60) return `${diff} sec ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return `${Math.floor(diff / 86400)} day${diff >= 172800 ? "s" : ""} ago`;
}

export default function RecentlyPurchased({ bookId, bookTitle }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!bookId) return;
    api.get(`/purchases/recent/${bookId}?limit=5`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [bookId]);

  if (!data || data.count === 0) return null;

  return (
    <div data-testid="recently-purchased" className="mt-8 border border-edge bg-linen p-5">
      <div className="flex items-center gap-2 label-eyebrow text-sage mb-3">
        <Users className="w-3.5 h-3.5" strokeWidth={1.5} />
        {data.count} {data.count === 1 ? "reader has" : "readers have"} bought this recently
      </div>
      <ul className="space-y-1.5">
        {data.items.map((p) => (
          <li key={p.purchased_at} className="text-sm text-muted_ink flex items-baseline gap-2">
            <span className="w-1 h-1 rounded-full bg-terracotta flex-shrink-0" />
            <span>Someone bought <span className="text-ink font-serif italic">{bookTitle}</span></span>
            <span className="text-xs">· {relativeTime(p.purchased_at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
